module.exports = __webpack_public_path__ + "img/Income Tax.cb72dfbf.png";